import enviro from 'enviro';
import * as Hublets from '../hublets';
export function getHubletPostfix(overrideConfig) {
  var hasHubletOverride = overrideConfig && overrideConfig.hubletOverride;
  var hubletToUse = hasHubletOverride ? overrideConfig.hubletOverride : enviro.getHublet();

  if (hubletToUse === Hublets.na1) {
    return '';
  }

  return "-" + hubletToUse;
}
export function getSubDomain(prefix, overrideConfig) {
  var hasHubletPostfixxOverride = overrideConfig && overrideConfig.hubletPostfixLocation && overrideConfig.hubletPostfixLocation === 'domain';

  if (hasHubletPostfixxOverride) {
    return prefix;
  }

  return "" + prefix + getHubletPostfix(overrideConfig);
}
export function getDomain(overrideConfig) {
  var domainPrefix = getDomainPrefix(overrideConfig);
  var envPostfix = getEnvPostfix(overrideConfig);
  var hubletDomainPostfix = getHubletDomainPostfix(overrideConfig);
  return "" + domainPrefix + envPostfix + hubletDomainPostfix;
}
export function getEnvPostfix(overrideConfig) {
  var hasEnvOverride = overrideConfig && overrideConfig.envOverride;
  var envToUse = hasEnvOverride ? overrideConfig.envOverride : enviro.getShort();

  if (envToUse === 'qa') {
    return 'qa';
  }

  return '';
}
export function getDomainPrefix(overrideConfig) {
  var hasDomainOverride = overrideConfig && overrideConfig.domainOverride;

  if (hasDomainOverride) {
    return overrideConfig.domainOverride;
  }

  return 'hubspot';
}
export function getHubletDomainPostfix(overrideConfig) {
  var hasHubletPostfixxOverride = overrideConfig && overrideConfig.hubletPostfixLocation && overrideConfig.hubletPostfixLocation === 'domain';

  if (!hasHubletPostfixxOverride) {
    return '';
  }

  return getHubletPostfix(overrideConfig);
}
export function getTld(overrideConfig) {
  var hasTldOverride = overrideConfig && overrideConfig.tldOverride;

  if (hasTldOverride) {
    return overrideConfig.tldOverride;
  }

  return 'com';
}